import {MantenimientoGaritasService} from './../../services/mantenimiento-garitas.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {UtilsService} from './../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from './../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';

@Component({
  selector: 'app-mantenimiento-garitas',
  templateUrl: './mantenimiento-garitas.component.html',
  styleUrls: ['./mantenimiento-garitas.component.scss'],
})
export class MantenimientoGaritasComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.mantenimientoGaritas;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: IGaritaResponse[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public garita: IGaritaResponse;

  public agregarGaritaForm = new FormGroup({
    idGarita: new FormControl(0),
    desca: new FormControl('', [Validators.required, Validators.pattern(/[A-Za-z]+/), Validators.maxLength(30)]),
    estado: new FormControl('', Validators.required),
  });

  constructor(
    private _util: UtilsService,
    private mantenimientoGaritasService: MantenimientoGaritasService
  ) {
  }

  get descaControl() {
    return this.agregarGaritaForm.get('desca');
  }

  get estadoControl() {
    return this.agregarGaritaForm.get('estado');
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idGarita',
        sortable: true,
        filter: true,
        width: 10,
      },
      {
        headerName: 'Descripción',
        field: 'desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.editarGarita.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 40,
      //   cellRendererParams: {
      //     onClick: this.eliminarGarita.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger,
      //   },
      // },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.agregarGaritaForm.get('idGarita')?.disable({onlySelf: true});
    this.girdComponent();
    this.obtenerGaritas();
  }

  obtenerGaritas() {
    this.loading = true;
    this.mantenimientoGaritasService.obtener().subscribe(
      (resp) => {
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditarGarita() {
    this.loading = true;
    if (this.agregarGaritaForm.invalid) return;
    this.garita = this.agregarGaritaForm.getRawValue();
    console.log('editar: post', this.garita);
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `${this.garita.desca}`,
        action: this.DAT_BTNS.editar,
        funcion: this.mantenimientoGaritasService.actualizar(this.garita),
      })
      .then(() => {
        this.obtenerGaritas();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarCrearNuevaGarita() {
    this.loading = true;
    if (this.agregarGaritaForm.invalid) return;
    this.garita = this.agregarGaritaForm.getRawValue();
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Garita: ${this.garita.desca}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.mantenimientoGaritasService.crear(this.garita),
      })
      .then(() => {
        this.obtenerGaritas();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminarGarita({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `${rowData.desca}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.mantenimientoGaritasService.borrar(rowData.idGarita),
      })
      .then((res: any) => {
        this.obtenerGaritas();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevaGarita() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarGaritaForm.reset();
    this.estadoControl.setValue('');
    this.openModal();
  }

  editarGarita({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    rowData.estado = rowData.estado == 'ACTIVO' ? 0 : 1;
    this.agregarGaritaForm.patchValue(rowData);
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNuevaGarita();
    if (!this.isCreate) this.guardarEditarGarita();
  }

  openModal() {
    document.getElementById('abrirModalGregarGarita').click();
  }

  closeModal() {
    document.getElementById('cerrarModalAgregarGarita').click();
  }
}
